/**
 * Catálogo e histórico de solicitações — usados pelas telas de Oportunidades e
 * de Serviços Adicionais (out/2026, conceito do Figma: lista de imóveis, cards
 * com custo e "contratado ✓", janela com o histórico de contratações).
 */
import {
  ServiceCatalogItem,
  ServiceRequestItem,
  ServiceType,
} from 'services/service_requests.service';
import { format } from './format';

/** Preço do serviço para exibir: fixo, "Sob consulta" ou vazio (sem preço). */
export const catalogPriceLabel = (item?: ServiceCatalogItem): string => {
  if (item?.price != null) return `R$ ${format.money(item.price)}`;
  if (item?.negotiable) return 'Sob consulta';
  return '';
};

/** Pedido ainda aberto (não dá para pedir de novo até a equipe concluir). */
export const isOpenRequest = (request: ServiceRequestItem): boolean =>
  request.status === 'requested' || request.status === 'in_progress';

/**
 * Pedidos de um serviço numa UC, mais recente primeiro, sem os cancelados.
 * `matches` refina quando vários cards usam o mesmo tipo de serviço (ex.: as
 * oportunidades que viram "Estudo de economia").
 */
export const requestHistory = (
  requests: ServiceRequestItem[],
  serviceType: ServiceType,
  consumerUnitId: string,
  matches?: (request: ServiceRequestItem) => boolean
): ServiceRequestItem[] =>
  requests
    .filter(
      (r) =>
        r.serviceType === serviceType &&
        r.consumerUnitId === consumerUnitId &&
        r.status !== 'canceled' &&
        (!matches || matches(r))
    )
    .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
